import React, { useState } from "react";
import { useQuery, gql } from "@apollo/client";
import FullFinalSettlement from "../UserManagement/EmployeeDashboard/FullFinalSettlement";

// Full & final from the Payouts screen: everyone marked as left, with where
// their settlement stands. Opening one shows the same statement as the
// Employee Dashboard's Full & final tab (prepare / settle there or here).

const GET_LEFT = gql`
  query GetPendingSettlementsForPayouts {
    getPendingSettlements {
      status
      message
      rows {
        employeeId
        fullName
        leavingDate
        status
        net
      }
    }
  }
`;

const inr = (n) => `₹${Math.round(Number(n) || 0).toLocaleString("en-IN")}`;
const STATUS = {
  NOT_STARTED: ["Not started", "bg-yellow-100 text-yellow-800"],
  DRAFT: ["Prepared - to settle", "bg-blue-100 text-blue-800"],
  SETTLED: ["Settled", "bg-green-100 text-green-800"],
};

const FullFinalList = () => {
  const { data, loading, refetch } = useQuery(GET_LEFT, { fetchPolicy: "network-only" });
  const [open, setOpen] = useState(null);
  const res = data?.getPendingSettlements;
  const rows = res?.rows || [];

  if (loading) return <p className="text-sm text-gray-500">Loading...</p>;
  if (res?.status === "ERROR") return <p className="text-sm text-red-600">{res.message}</p>;
  return (
    <div className="space-y-3">
      <p className="text-sm text-gray-500">
        Everyone marked Employed off with a last working day. One admin prepares the statement, another settles it.
        Settled months are left out of payroll.
      </p>
      {rows.length === 0 ? (
        <p className="text-sm text-gray-400">Nobody has left yet.</p>
      ) : (
        rows.map((r) => {
          const [label, cls] = STATUS[r.status] || [r.status, "bg-gray-100"];
          const isOpen = open === r.employeeId;
          return (
            <div key={r.employeeId} className="border rounded-lg">
              <button
                onClick={() => {
                  setOpen(isOpen ? null : r.employeeId);
                  if (isOpen) refetch();
                }}
                className="w-full flex items-center gap-4 px-4 py-3 text-left hover:bg-gray-50"
              >
                <span className="font-semibold text-gray-800">{r.fullName}</span>
                <span className="text-xs text-gray-500">Left {r.leavingDate}</span>
                <span className={`px-2 py-0.5 rounded text-[11px] font-semibold ${cls}`}>{label}</span>
                <span className="text-xs text-gray-600">
                  {r.net === null ? "" : r.net >= 0 ? `Pay ${inr(r.net)}` : `Collect ${inr(-r.net)}`}
                </span>
                <span className="ml-auto text-xs font-semibold text-blue-600">{isOpen ? "Close" : "Open"}</span>
              </button>
              {isOpen && (
                <div className="border-t px-4 py-4">
                  <FullFinalSettlement employeeId={r.employeeId} />
                </div>
              )}
            </div>
          );
        })
      )}
    </div>
  );
};

export default FullFinalList;
